import type { IconData } from '@stacksjs/iconify-core'

export const webSection: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M14 2h2v20h-2z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M3 2h11v20H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M16 2h5a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default webSection
